import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, LoadingController } from 'ionic-angular';
import { CurrencyPipe } from '@angular/common';

import { SchedulePage, TaskPage, NotesPage, FormTenderPage, ActivityPage, ListTenderSubscribersPage } from '..';
import { UserMarketing as User, TenderMarketing as Tender } from '@providers/index'
import { PostTenderPage } from '../post_tender/page';

@Component({
  selector: 'page-project-detail',
  templateUrl: 'page.html'
})
export class ProjectDetailPage {

  tender : any={};
  tender_id ='';
  tender_approval: any;
  akses          : any={};
  can_edit=false;

  constructor(
    public navCtrl        : NavController,
    public navParams      : NavParams,
    public actionSheetCtrl: ActionSheetController,
    public loadingCtrl    : LoadingController,
    public userApi        : User,
    public tenderApi      : Tender,
    private currency      : CurrencyPipe
  ) {

    this.tender_id = this.navParams.get('tender_id');
    this.akses = this.userApi.akses;
    
    if(this.userApi.akses.edit_tender_group_data=='branch'){
      if(this.tender.branch_id == this.userApi.group.user_data){
        this.can_edit=true;
      }
    }else if(this.userApi.akses.edit_tender_group_data=='all'){
      this.can_edit = true;
    }else if(this.userApi.akses.edit_tender_group_data=='mine'){
      if(this.tender.created_by == this.userApi.data.employee_id){
        this.can_edit=true;
      }
    }

  }

  ionViewDidEnter(){
    this.getTender();
    this.getTenderApproval();
  }

  getTender(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params: any = {tender_id:this.tender_id};

    this.tenderApi.get(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.tender = resp.data[0];
        console.log(resp.data[0]);
        loading.dismiss();
      }else{
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });


  }

  toSchedule() {
    this.navCtrl.push(SchedulePage, {
      tender : this.tender
    });
  }

  toTaskList() {
    this.navCtrl.push(TaskPage, {
      tender : this.tender
    });
  }

  toNotes() {
    this.navCtrl.push(NotesPage, {
      tender : this.tender
    });
  }

  editTender() {
    let params : any = {
      tender    : this.tender,
      form_type : 'edit'
    }
    if(this.tender.bid_number =='' || this.tender.bid_number == null){
      params.bid_edit = true
    }else{
      
    }
    this.navCtrl.push(FormTenderPage, params);
  }

  toActivity(){
    let pids = [this.tender_id];
    
    this.navCtrl.push(ActivityPage,{
      tender_ids : pids
    });
  }

  toListSubscribers(){
    this.navCtrl.push(ListTenderSubscribersPage, {
      tender_id : this.tender_id
    });
  }

  toPostTender(){
    this.navCtrl.push(PostTenderPage, {
      tender : this.tender
    });
  }

  getTenderApproval(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params: any = {tender_id:this.tender_id};
    this.tenderApi.getTenderApproval(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.tender_approval = resp.data;
        console.log(resp.data);
        loading.dismiss();
      }else{
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/project-detail/page.ts